export default __webpack_public_path__ + "static/cover-8-11805fcc384bca621a71cc08bdee351a.jpg";